import Main from "./routes/Main";

function App() {
  return <Main />;
}

export default App;